export default class AbstractPreloader {
    public load(waiting = false): Promise<1> {
        return Promise.resolve(1);
    }

    public postLoadPreparation(): void {
        // abstract method
    }
}
